import AsyncStorage from '@react-native-async-storage/async-storage'

interface IAppStorage {
  setItem(key: string, objString: string);
  getItem(key: string): string;
  removeItem(key: string);
}

export class AppStorage implements IAppStorage {
  static async setItem(key: string, objString: string) {
    await AsyncStorage.setItem(key, objString)
  }

  static async getItem(key: string) : string {
    return await AsyncStorage.getItem(key)
  }

  static async removeItem(key: string) {
    await AsyncStorage.removeItem(key)
  }
}